// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 合思配置表单项
 * @constructor
 */
const BeiSenFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "grant_type"]}
        label={"grant_type"}
        placeholder={"请输入grant_type"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入grant_type"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "app_key"]}
        label={"app_key"}
        placeholder={"请输入app_key"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入app_key"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "app_secret"]}
        label={"app_secret"}
        placeholder={"请输入app_secret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入app_secret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.BEISEN})
          return _data
        }}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default BeiSenFormItems
